var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "demo-block",
      class: [_vm.blockClass, { hover: _vm.hovering }],
      on: {
        mouseenter: function($event) {
          _vm.hovering = true
        },
        mouseleave: function($event) {
          _vm.hovering = false
        }
      }
    },
    [
      _c("div", { staticClass: "source" }, [_vm._t("source")], 2),
      _vm._v(" "),
      _c("div", { ref: "meta", staticClass: "meta" }, [
        _vm.$slots.default
          ? _c("div", { staticClass: "description" }, [_vm._t("default")], 2)
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "highlight" }, [_vm._t("highlight")], 2)
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "control",
          staticClass: "demo-block-control",
          class: { "is-fixed": _vm.fixedControl },
          on: {
            click: function($event) {
              _vm.isExpanded = !_vm.isExpanded
            }
          }
        },
        [
          _c("transition", { attrs: { name: "arrow-slide" } }, [
            _c("i", { class: [_vm.iconClass, { hovering: _vm.hovering }] })
          ]),
          _vm._v(" "),
          _c("transition", { attrs: { name: "text-slide" } }, [
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.hovering,
                    expression: "hovering"
                  }
                ]
              },
              [_vm._v(_vm._s(_vm.controlText))]
            )
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-881acf0e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-881acf0e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./examples/components/DemoBlock.vue
// module id = null
// module chunks = 